import { getCurrentDate, getCurrentDateOfBelow, getCurrentYearOfFiveBelow } from "../../services/DateServices";
export default {
    contract: "",
    serialNumber: "",
    samplingFromDate: getCurrentDateOfBelow(365),
    samplingToDate: getCurrentDate(),
    assetDescription: "",
    location: "",
    customerKey: ""
}